'use client'

import { useEffect } from 'react'
import ErrorFallback from '@/components/shared/ErrorFallback'
import { reportErrorToDD } from '@/lib/analytics/datadogError'
import { trackClientError } from '@/lib/trackClientError'

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        const pathname = typeof window !== 'undefined' ? window.location.pathname : undefined
        reportErrorToDD(error, {
            source: 'route_error_boundary',
            ...(error.digest && { digest: error.digest }),
            ...(pathname && { pathname }),
        })
        trackClientError({
            error,
            source: 'route_error_boundary',
        })
    }, [error])

    return (
        <ErrorFallback
            title="Something went wrong"
            message="An unexpected error occurred. Please try again."
            showRetryButton
            retryButtonText="Try Again"
            onRetry={reset}
            showHomeButton
        />
    )
}
